export default {
  hzmbG: {
    title: {
      hzmbG: "Parking of Hong Kong Goods Vehicles\n at the Macao Cross-Border Cargo Transfer Terminal",
      application: "Application information",
      vehicle: "Vehicle information",
      owner: "Vehicle owner information",
      drivers: "Driver information",
      driversIndex: "{0} driver",
      cancelDescription: "Description of cancellation",
      auth: "Identity verification"
    },
    label: {
      registrationNo: "Hong Kong vehicle registration number",
      identificationNo: "Vehicle chassis number",
      mobile: "Vehicle owner's mobile phone (for SMS notification)",
      mobileAreaCode: "Area code",
      mobiltTips: "The inquired number will be sent by SMS and email. Please make sure the relevant information is correct.",
      validType: "Verification type",
      approveNo: "Macao approval number",
      identificationNoLast4: "Last 4 characters of vehicle chassis number",
      registerType: "Registration type",
      identType: "Type of identity document",
      identNo: "Number of identity document",
      companyRegistrationType: "Type of Certificate of Incorporation",
      companyRegistrationNo: "Number of Certificate of Incorporation",
      mainlandRegistrationNo: "Mainland vehicle registration number",
      registrationType: "Type of Hong Kong vehicle registration",
      factory: "Factory name",
      modelType: "Model",
      buildYear: "Year of manufacture",
      firstRegisterDate: "Date of first registration",
      color: "Color",
      driverSeat: "Driver seat position",
      passengerCount: "Seating capacity (excluding driver)",
      engineNo: "Engine number",
      permitWeight: "Gross weight of permitted vehicle",
      licenseExpireDate: "Expiration date of Hong Kong vehicle license",
      mainlandInsuranceNo: "Number of Mainland insurance policy",
      mainlandInsuranceStartDate: "Effective date of Mainland insurance policy",
      mainlandInsuranceEndDate: "End date of Mainland insurance policy",
      ownerNameEn: "English name of vehicle owner",
      identityType: "Type of identity document",
      identityNo: "Number of identity document",
      address: "Address",
      ownerCompanyNameEn: "Company name in English",
      companyIdentityType: "Type of Certificate of Incorporation",
      companyRegisterNo: "Number of Certificate of Incorporation",
      companyAddress: "Company address",
      macauMobile: "Phone number",
      email: "Email address",
      driverNameEn: "English name",
      hongKongDrivingLicenseType: "Type of Hong Kong driving license (class)",
      hongKongDrivingLicenseNo: "Number of Hong Kong driving license",
      birthday: "Date of birth",
      sex: "Gender",
      nationality: "Nationality",
      cancelReason: "Reason for cancellation",
      mainlandDrivingFileNo: "File number of Mainland driving permit",
      mainlandDrivingLicenseNo: "Number of Mainland driving license",
      personal: "Individual",
      company: "Company/Institution"
    },
    message: {
      registrationNo: "Please enter Hong Kong vehicle registration number",
      identificationNo: "Please enter vehicle chassis number",
      mobile: "Please enter vehicle owner's mobile phone (for SMS notification)",
      vcode: "Please perform security verification first",
      approveNo: "Please enter Macao approval number",
      identificationNoLast4: "Please enter last 4 characters of vehicle chassis number",
      registerType: "Please enter registration type",
      identNo: "Please enter number of identity document",
      companyRegistrationNo: "Please enter number of Certificate of Incorporation",
      mainlandRegistrationNo: "Please enter Mainland vehicle registration number",
      registrationType: "Please enter type of Hong Kong vehicle registration",
      factory: "Please enter factory name",
      modelType: "Please enter model",
      buildYear: "Please enter year of manufacture",
      firstRegisterDate: "Please enter date of first registration",
      color: "Please enter color",
      driverSeat: "Driver seat position",
      engineNo: "Please enter motor number {0}",
      permitWeightTable: {
        title: "The existing laws in Macao impose the following limits on the gross weight of vehicles:",
        type: "Vehicle type",
        weight: "Limit on gross weight",
        two: "Two axles",
        three: "Three axles",
        four: "Four axles",
        fiveOrMore: "Five axles or above",
        type1: "Vehicle only",
        type2: "Combination of tractor and semi-trailer",
        type3: "Combination of vehicle and trailer"
      },
      vehicleType: "Vehicle type",
      vehicleType1: "Vehicle only",
      vehicleType2: "Combination of tractor and semi-trailer",
      vehicleType3: "Combination of vehicle and trailer",
      permitWeight: "Please enter gross weight of permitted vehicle",
      ton: "Ton",
      permitWeightTip1: "10-ton weight limit for one axle",
      permitWeightTip2: "16-ton weight limit for two axles",
      permitWeightTip3: "22-ton weight limit for three axles or above",
      permitWeightFloat: "Reserve a maximum of one decimal place",
      permitWeightMax: "Please enter correct gross weight of permitted vehicle",
      licenseExpireDate: "Please enter expiration date of Hong Kong vehicle license",
      vehicleSize: {
        title: "The existing laws in Macao impose the following limits on the maximum body size of vehicles:",
        max: "Limit on maximum size",
        length: "Length",
        weight: "Width",
        height: "Height (from the ground)"
      },
      mainlandInsuranceNo: "Please enter number of Mainland insurance policy",
      mainlandInsuranceStartDate: "Please enter effective date of Mainland insurance policy",
      mainlandInsuranceEndDate: "Please enter end date of Mainland insurance policy",
      ownerNameEn: "Please enter English name of vehicle owner",
      nameEnChcek: "Only English letters and characters are required",
      company_nameEnChcek: "Only English letters, figures and characters are required",
      identityNoCheck: "Only English letters and figures are required",
      identityType: "Please enter type of identity document",
      identityNo: "Please enter number of identity document",
      address: "Please enter address",
      ownerCompanyNameEn: "Please enter company name in English",
      companyIdentityType: "Please enter type of Certificate of Incorporation",
      companyRegisterNo: "Please enter number of Certificate of Incorporation",
      companyAddress: "Please enter company address",
      macauMobile: "Please enter phone number",
      email: "Please enter email address",
      email_confirm: "Please enter email address again",
      emial_confirm_tip: "Please make sure to enter the same email address twice",
      driverNameEn: "Please enter English name",
      hongKongDrivingLicenseType: "Please enter type of Hong Kong driving license (class)",
      hongKongDrivingLicenseNo: "Please enter number of Hong Kong driving license",
      hongKongDrivingLicenseNoCheck: "Please enter English alphabet ,numbers or “/”",
      birthday: "Please enter date of birth",
      sex: "Please enter gender",
      nationality: "Please enter nationality",
      agreeVehicleSize: "It is acknowledged and undertaken that Hong Kong goods vehicles using the Macao Cross-Border Cargo Transfer Terminal shall not exceed the above maximum body size.",
      checkTips: "The inquired number will be sent by SMS and email. Please make sure the relevant information is correct.",
      mainlandDrivingFileNo: "Please enter file number of Mainland driving permit",
      mainlandDrivingLicenseNo: "Please enter number of Mainland driving license",
      driversIdentityNo: "If you are a Mainland driver,please enter “Exit-Entry Permit for Travelling to and from Hong Kong and Macao” number"
    },
    enum: {
      areas: {
        macau: 'Macau + 853',
        hongkong: 'Hong Kong + 852',
        mainland: "China +86"
      },
      registerType: {
        PERSON: "Register as an individual",
        COMPANY: "Register as a company/institution"
      },
      driverSeat: {
        E: "Left steering wheel",
        D: "Right steering wheel"
      },
      hkVehicleRegisterType: {
        LIGHT_TRUCK: "Light goods vehicle",
        MEDIUM_TRUCK: "Medium goods vehicle",
        HEAVY_TRUCK: "Heavy goods vehicle",
        TRACTOR: "Tractor",
        TOW_TRUCK: "Trailor"
      }
    },
    success: {
      title: "The application was successful",
      applicationNo: "Application number: "
    },
    terms_hzmbG_first: "<p>" +
      "  1. Matters to be Complied with" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>Each application can be allocated to no more than three designated drivers, and the designated drivers shall hold the relevant effective Hong Kong commercial vehicle driving licenses issued by the Hong Kong authorities.</li>" +
      "  <li>Upon obtaining the permit, if the vehicle using the permit (hereinafter referred to as the \"permitted vehicle\") or the vehicle registration number needs to be changed, a letter must be sent to the Transport Bureau to cancel the original registration before re-application.</li>" +
      "  <li>The permit shall not be transferred. If the owner of the vehicle is changed to another owner within the validity period of the permit (the permit holder is no longer the owner of the permitted vehicle), the relevant permit will be canceled.</li>" +
      "  <li>The permitted vehicle shall be registered by the permit holder/company in Hong Kong as a light goods vehicle, medium goods vehicle, heavy goods vehicle, tractor or trailer and shall comply with the regulations of the Road Traffic Ordinance of Macau on limiting the length, width and gross weight of goods vehicles, with the height not exceeding 4.6 meters. The permit holder/company must ensure that the permitted vehicle has the effective compulsory vehicle insurance in three places (i.e., Mainland China, Hong Kong and Macao) when using the Hong Kong-Zhuhai-Macao Bridge (HZMB).</li>" +
      "  <li>The permitted vehicle and its designated drivers shall comply with the relevant laws and regulations of Hong Kong and Macao. In addition, the permitted vehicle and the drivers shall follow the laws and regulations of Mainland China and the provisions formulated by Mainland China for vehicles that circulate between Hong Kong and Macao but do not enter Zhuhai, when crossing the Main Bridge of the HZMB, as the Main Bridge is within the jurisdiction of Mainland China.</li>" +
      "  <li>The permitted vehicle, with the effective permit, the effective Closed Road Permit for Cross-boundary Vehicles (CRP) issued by the Transport Department of the Government of the Hong Kong SAR, the effective \"Provisional Driving Permit\" and \"Provisional Entry Driving License\" issued by Mainland China, as well as effective three-place insurance, can be driven by a designated driver with an effective Hong Kong commercial vehicle driving license across the HZMB to the Macao Cross-Border Cargo Transfer Terminal (the Terminal) for operation. Any person shall be liable for the consequences that the permitted vehicle fails to circulate between Hong Kong and Macao via the HZMB for reasons of his own, Mainland China, or Hong Kong.</li>" +
      "  <li>If the permit holder, the designated drivers, or the permitted vehicle violates the provisions for the permit application and relevant licenses of Hong Kong and Macao, the relevant permit or licenses will be canceled, and their application for the licenses or permit will not be accepted. If the permit, licenses, or entry qualification is canceled, the corresponding licenses and permit will be canceled as well.</li>" +
      "  <li>If Mainland China cancels the entry qualification of the relevant vehicle or applicant in conformity with the regulations of Mainland China, the relevant licenses and permit will be canceled, and the application for the licenses and permit will not be accepted.</li>" +
      "  <li>If the permit holder or the designated driver is found to have taken advantage of the permitted vehicle for illegal activities, such as smuggling, transporting people across the border illegally, illegal operations (including \"pak pai (illegal taxi)\"), carrying articles prohibited or restricted from entry and exit in violation of regulations, and failing to declare for luggage or goods subject to inspection and quarantine, the permit corresponding to the vehicle will be canceled.</li>" +
      "  <li>All data completed and submitted by the applicant and the permit holder shall be true; otherwise, their application will not be accepted or their permit will be canceled.</li>" +
      "  <li>If the permitted vehicle leaves Macao beyond the time limit without justifiable reasons, its booking will be suspended for 15 days after 30 days from the date of departure from Macao or confirmation of the matter.</li>" +
      "  <li>If the permitted vehicle goes out of the circulation zone, fails to obey the circulation conditions, or is not driven by the designated driver, its permit will be canceled.</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  2. Protection of Personal Data" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>As the owner of this website, the Transport Bureau (\"DSAT\") warrants that all its personnel comply with all relevant regulations, and your personal data will be processed under confidentiality measures and will be kept properly. Such personal data will be kept until it is no longer needed for the purpose for which it was collected, or until the preservation period stipulated by the government. By then, the data will be destroyed in accordance with relevant regulations.</li>" +
      "  <li>You have the right to access and modify your personal data stored in this website at DSAT, or to access and modify your personal data stored at other government departments that have received and saved the data forwarded by DSAT.</li>" +
      "  <li>All personal data provided by applicants will be processed in accordance with the provisions of the Personal Data Protection Act (Law No. 8/2005 of Special Administrative Region of Macao). In case of any doubt when reviewing the documents, DSAT may submit the relevant data to an authorized institution for verification or inquiry. Applicants are entitled to the right of information, access, correction and opposition according to law and the exercise of the relevant rights must be submitted to DSAT in writing. Before submitting any personal data to DSAT, applicants must have obtained the consent of data subjects and provided them with the information specified in Paragraph 1, Article 10 of the Personal Data Protection Act (Law No. 8/2005).</li>" +
      "  <li>You have the right to access and modify your personal data stored in this website at DSAT, or to access and modify your personal data stored at other government departments that have received and saved the data forwarded by DSAT. For the purpose of processing relevant applications, DSAT and the relevant administrative authorities (including the respective administrative authorities from Mainland China, Hong Kong and Macao) may provide to each other, exchange, confirm and use the personal data of vehicles, owners and drivers involving the interested parties by any means including data interconnection in accordance with the provisions of the Personal Data Protection Act (Law No. 8/2005).</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  3. Disclaimer" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>DSAT has made every effort to ensure that the contents on this website are accurate, but does not make any express or implied warranty or undertaking regarding such contents. All data is provided on an \"as is\" basis and DSAT does not assume any responsibility. DSAT also reserves the right to delete, temporarily suspend the provision of, or edit the data on this website at any time without giving any prior notice. DSAT does not assume any responsibility or make any compensation for any damage or loss arising from the use of the data on this website.</li>" +
      "  <li>This website will update the rules of use for optimizing the supervision and operation of this system item in due time. Please follow the latest announcements of this website in order to obtain timely information.</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  4. Privacy Policy" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>The personal data input into this system by applicants and users will only be used in this system and printed on electronic receipts (if any).</li>" +
      "  <li>This service uses Secure Sockets Layer (SSL) to keep the data entered by users on this webpage confidential.</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  5. Changes to Terms of Use" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>If there is any update to these Terms of Use, DSAT will replace the old version with the new one and list the update date in the file. No separate announcement will be made.</li>" +
      "</ul>" +
      "<p></p>" +
      "<p>" +
      "  6. Contact Information" +
      "  <br />" +
      "</p>" +
      "<ul>" +
      "  <li>Addr.: Estrada de D. Maria II, No. 33, Macau, Reception Area of the Transport Bureau (Estrada de D. Maria II)</li>" +
      "  <li>Office hours: 9:00 a.m. to 18:00 p.m. (open as usual at noon), Monday to Friday)</li>" +
      "  <li>Transport affairs hotline: (853) 8866 6363</li>" +
      "  <li>Email: info@dsat.gov.mo</li>" +
      "</ul>",
    terms_hzmbG_cancel:
      "<ul>" +
      "  <li>進入【香港貨車-停泊澳門跨境貨物轉運站】模塊，點擊【取消】模塊，勾選同意使用規章，便可進入服務頁面。</li>" +
      "  <li>輸入身份驗證信息，可通過澳門批准編號或香港車輛登記號碼驗證；選擇登記類型，可選擇以個人作登記或以公司/單位作登記；輸入本澳流動電話，獲取並輸入驗證碼後，便可提交驗證。</li>" +
      "  <li>驗證通過後便可進入信息確認頁面，申請信息中顯示顯示車輛的澳門批准編號、香港車輛登記號碼、車身底盤號碼及流動電話，不可編輯。</li>" +
      "  <li>輸入取消原因，並勾選注意事項，點擊“確認提交”便可提交申請。</li>" +
      "</ul>",
      Vcode: {
        title: "Security verification",
        successText: "Verification passed",
        failText: "Verification failed. Please try again",
        sliderText: "Drag the slider to fit the puzzle",
        success: "Verification passed"
      }
  },
  hzmbGInsurance: {
    label: {
      noticePhone: "Vehicle owner's mobile phone (for SMS notification)",
      admittanceStartDate: "Start date for entry into Macao",
      admittanceEndDate: "End date for entry into Macao",
      registrationType: "Hong Kong vehicle type",
      identificationNo: "Hong Kong chassis number",
      mainlandInsuranceNo: "Insurance policy number",
      mainlandInsuranceStartDate: "Effective date of insurance policy",
      mainlandInsuranceEndDate: "End date of insurance policy",
    },
    title: {
      boxTitle1: "Macao insurance information",
    },
    message: {
      noChinese: "Only English letters, figures and characters are required",
    },
  },
};
